import { sendSegmentEvent } from '../segment';

export default function trackSeekerAccountCreation(accountProperties) {
  sendSegmentEvent('Account Created', accountProperties);
  sendSegmentEvent('Criteo Intent Displayed', { product_id: '1' });
  if (accountProperties.familyType) {
    sendSegmentEvent('Family Role Assigned', accountProperties);
  }
}
